import React from 'react';

function Step1({ formData, errors, onChange }) {
  
  // Función para bloquear físicamente la pulsación de números (0-9) en el teclado
  // Solo permite letras, espacios, tildes y ñ
  const blockNumbers = (e) => {
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]$/;

    // Permitir teclas de control
    if (
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "Tab" ||
      e.key === "ArrowLeft" ||
      e.key === "ArrowRight" ||
      e.key === "Home" ||
      e.key === "End"
    ) {
      return;
    }

    if (!regex.test(e.key)) {
      e.preventDefault();
    }
  };

  // Función para evitar que el usuario copie y pegue texto que contenga números
  const blockNumbersOnPaste = (e) => {
    const texto = e.clipboardData.getData("text");
    const regex = /^[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]+$/;

    if (!regex.test(texto)) {
      e.preventDefault();
    }
  };

  return (
    <div className="step-panel">
      <div className="field-group">
        <label htmlFor="nombres">
          Nombres y Apellidos Completos <span className="required">*</span>
        </label>
        <input
          id="nombres"
          name="nombres"
          type="text"
          value={formData.nombres || ''}
          onChange={onChange}
          onKeyPress={blockNumbers}       // Bloquea la escritura de números en tiempo real
          onPaste={blockNumbersOnPaste}   // Bloquea el pegado de texto con números
          placeholder="Ingrese su nombre completo"
        />
        {errors.nombres && <span className="field-error">{errors.nombres}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="tipoDocumento">
          Tipo de Documento <span className="required">*</span>
        </label>
        <select
          id="tipoDocumento"
          name="tipoDocumento"
          value={formData.tipoDocumento || ''}
          onChange={onChange}
        >
          <option value="">Select an option ...</option>
          <option value="ti">Tarjeta de Identidad</option>
          <option value="cc">Cédula de Ciudadanía</option>
          <option value="ce">Cédula de Extranjería</option>
          <option value="passport">Pasaporte</option>
          <option value="ppt">Permiso de Protección Temporal</option>
        </select>
        {errors.tipoDocumento && <span className="field-error">{errors.tipoDocumento}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="documento">
          No. Documento de Identidad <span className="required">*</span>
        </label>
        <input
          id="documento"
          name="documento"
          type="text"                     // Forzamos tipo texto para controlar la longitud sin bugs de flechas
          maxLength="10"                  // Bloquea físicamente que escriban más de 10 caracteres
          value={formData.documento || ''}
          onChange={onChange}
          onKeyPress={(e) => {
            // Bloqueo físico: Si la tecla presionada NO es un número, cancela el evento
            if (e.key < '0' || e.key > '9') {
              e.preventDefault();
            }
          }}
          placeholder="Ingrese su número de documento"
        />
        {errors.documento && <span className="field-error">{errors.documento}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="fechaNacimiento">
          Fecha de Nacimiento <span className="required">*</span>
        </label>
        <input
          id="fechaNacimiento"
          name="fechaNacimiento"
          type="date"
          value={formData.fechaNacimiento || ''}
          onChange={onChange}
        />
        {errors.fechaNacimiento && <span className="field-error">{errors.fechaNacimiento}</span>}
      </div>

      <div className="field-group">
        <label htmlFor="paisNacimiento">
          País de Nacimiento <span className="required">*</span>
        </label>
        <select
          id="paisNacimiento"
          name="paisNacimiento"
          value={formData.paisNacimiento || ''}
          onChange={onChange}
        >
          <option value="">Select an option ...</option>
          <option value="colombia">Colombia</option>
          <option value="otro">Otro</option>
        </select>
        {errors.paisNacimiento && <span className="field-error">{errors.paisNacimiento}</span>}
      </div>
    </div>
  );
}

export default Step1;